module.exports = __webpack_public_path__ + "static/media/29BDOS23.26ea0c6e.jpg";